import React, { useState } from 'react';
import { GetUserAssetResult, GetUserBrokerResultItem } from 'config/api';
import { AssetBundleType } from 'components/features/home/Home';
import { PortfolioStuffingAsset } from './asset/PortfolioStuffingAsset';
import { PortfolioStuffingDebt } from './debt/PortfolioStuffingDebt';
import { updateRoutigList } from '../Tab';

type PortfolioStuffingProps = {
  asset: GetUserAssetResult;
  brokersInfo: GetUserBrokerResultItem[];
  UserBrokerUpdateTime: React.ReactElement;
  assetBundleType: AssetBundleType;
  getIsOutOfDate: (arg: { account: string }) => boolean | null;
  toPreview: (element: React.ReactElement) => void;
  backHome: () => void;
};

export type DispType = '資産' | '負債';

const convertToDispType = (type: string): DispType => {
  switch (type) {
    case 'debt':
      return '負債';
    case 'asset':
    default:
      return '資産';
  }
};

export const PortfolioStuffing = ({
  asset,
  brokersInfo,
  UserBrokerUpdateTime,
  assetBundleType,
  getIsOutOfDate,
  toPreview,
  backHome,
}: PortfolioStuffingProps): React.ReactElement => {
  const urlParams = new URLSearchParams(window.location.search);
  const initialSelectedType = convertToDispType(
    urlParams.get('tab') || 'asset'
  );
  const [dispType, setDispType] = useState<DispType>(initialSelectedType);

  const changeDispType = (dispType: DispType): void => {
    setDispType(dispType);
    updateRoutigList('assetsheld', dispType === '資産' ? 'asset' : 'debt');
  };

  return (
    <>
      <div
        className="absolute top-10 w-full ml-auto mr-auto z-10"
        style={{ top: '2rem' }}>
        <div
          className="flex flex-row justify-center absolute left-0 right-0 mx-auto my-0"
          style={{ width: '100px' }}>
          <div
            className={`border border-white py-1 px-3 text-xs rounded-l ${
              dispType === '資産' ? 'bg-white' : 'text-white'
            } cursor-pointer`}
            onClick={(): void => changeDispType('資産')}>
            資産
          </div>
          <div
            className={`border border-white py-1 px-3 text-xs rounded-r ${
              dispType === '負債' ? 'bg-white' : 'text-white'
            } cursor-pointer`}
            onClick={(): void => changeDispType('負債')}>
            負債
          </div>
        </div>
      </div>
      {dispType === '資産' ? (
        <PortfolioStuffingAsset
          {...{
            asset,
            brokersInfo,
            UserBrokerUpdateTime,
            assetBundleType,
            getIsOutOfDate,
            backHome,
            toPreview,
          }}
        />
      ) : (
        <PortfolioStuffingDebt
          {...{
            UserBrokerUpdateTime,
            groupKey: assetBundleType.key,
          }}
        />
      )}
    </>
  );
};
